import * as NestedQueries from "../../templates/joining-queries";
import * as TermQueries from "../../templates/term-queries";
import * as FtsQueries from "../../templates/fts-queries";

const ID_PROP = "id";

export const relationsByIdQuery = (relations: Array<string>, queryVariable: string): string => {
  return relations.map(relation => {
    return NestedQueries.nested({
      property: relation,
      query: TermQueries.term({
        property: ID_PROP,
        value: queryVariable
      }),
      ignore_unmapped: true
    });
  }).join(',');
};

export const relationsByTextQuery = (relations: Array<string>, queryVariable: string): string => {
  return relations.map(relation => {
    return NestedQueries.nested({
      property: relation,
      query: FtsQueries.multiMatch({
        query: queryVariable,
        analyzer: 'standard',
        type: 'phrase_prefix'
      }),
      ignore_unmapped: true
    });
  }).join(',');
};
